import request from '@/utils/request';
import Resource from '@/api/resource';

class ChannelResource extends Resource {
  constructor() {
    super('channel/jrtt');
  }

  /** 批量新增渠道 */
  batchAddChannelApi(data) {
    return request({
      url: `/${this.uri}/batchAdd`,
      method: 'POST',
      data,
    });
  }
}

export { ChannelResource as default };
